import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/tourAdditionalOptions', request)
}

export {get}
